import React, { Component } from "react";
import { Container } from 'react-bootstrap'
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";
import HostelAttendanceSection from "../components/HostelAttendance/HostelAttendanceSection";
import { HostelShimmer } from "../components/HostelAttendance/HostelShimmer";

const GET_STUDENT_DETAILS = gql`
query($institute_id:Int){
    getNewEducationalStudents(institute_id: $institute_id) {
        roll_no
        student_name
        class_id
        class_name
        branch_id
        branch_name
        section_id
        section_name
        parent_name
        parent_mobile
        parent_password
        student_id
      }
}
`
class HostelAttendance extends Component {
    constructor(props) {
        super(props)
        this.state = {
            toggled: Cookies.get("toggle")
        }
    }
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };

    render() {
        const getNewEducationalStudents = this.props.getNewEducationalStudents;
        const loading2 = getNewEducationalStudents.loading;
        const error2 = getNewEducationalStudents.error

        if (error2 !== undefined) {
            alert("Server Error. " + error2.message);
            return null;
        }
        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <NavbarOne onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">
                    <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
                        <SideNavbar />
                    </div>
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper mb-2">
                        {
                            loading2 ?
                                (
                                    <HostelShimmer filters={5} />
                                ) :
                                (
                                    <HostelAttendanceSection
                                        getNewEducationalStudents={getNewEducationalStudents.getNewEducationalStudents}
                                    />
                                )
                        }
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}
export default withRouter(compose(
    graphql(GET_STUDENT_DETAILS, {
        options: (props) => ({
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
            },
        }),
        name: "getNewEducationalStudents",
    }),
)(HostelAttendance));
